import { SearchCriteria } from 'src/app/core/interfaces/search-criteria.interface';
import { CollectionFinderItemDTO } from 'src/app/core/interfaces/collection.interface';
import { FIELD_PRIORITY_WEIGHT, SEARCH_FIELD, SearchPriorityConfig } from 'src/app/core/interfaces/search-priority-config';

export class CollectionKeywordsCriteria implements SearchCriteria {
  getMatchScore(_collection: CollectionFinderItemDTO, _query: string): number {
    if (!_collection.keywords) return 0;
    return _collection.keywords.some((keyword) => {
      return keyword.toLowerCase().includes(_query);
    })
      ? 1
      : 0;
  }
  getRelevanceFieldWeightAndMatchScore(_collection: CollectionFinderItemDTO, _query: string): SearchPriorityConfig {
    return {
      relevanceField: SEARCH_FIELD.TAGS,
      fieldPriorityWeight: FIELD_PRIORITY_WEIGHT.TAGS,
      matchScore: this.getMatchScore(_collection, _query)
    }
  }
}
